module.exports = __webpack_public_path__ + "img/ancient_keeper_small.ef22ffca.png";